import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ButtonComponent } from './button/button.component';
import { ErrorComponent } from './error/error.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { LoaderComponent } from './loader/loader.component';

@NgModule({
    declarations: [LoaderComponent, FeedbackComponent, ButtonComponent, ErrorComponent],
    imports: [CommonModule, MatProgressSpinnerModule, TranslateModule],
    exports: [
        LoaderComponent,
        MatProgressSpinnerModule,
        FeedbackComponent,
        TranslateModule,
        NgCircleProgressModule,
        ButtonComponent,
        ErrorComponent
    ],
})
export class SharedModule {}
